export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";